/* Redraw and align the bevel facets. Added by Claude.
   To revert, delete this file and its <script> tag in layout/theme.liquid.

   The construction in mr-dropdown-facets.js - two diagonals per corner to the
   chamfer ends, outer rectangles clipped at the diagonals by intersection - is
   correct and met cleanly when it was built. Nothing here changes geometry. This
   file only makes sure the drawing happens at the right size and in the right
   place, which is where it has been going wrong since the font changed.

   ---- 1. REDRAW AFTER THE WEBFONTS LOAD ----
   The facet script primes every panel at DOMContentLoaded, while Sackers is still
   swapping in, so the first drawing is for the fallback font's dimensions.
   Dispatching resize after document.fonts.ready reuses the script's own full
   rebuild: remove every SVG, clear the stamps, re-prime.

   ---- 2. REDRAW WHEN A DROPDOWN OPENS ----
   prime() measures each panel forced briefly into position:absolute. If the
   panel lays out differently when genuinely open, every w-dependent line moves,
   and the corner diagonals visibly miss the chamfer. The script's safety-net
   observer would catch this, but it watches attributes and a hover-opened
   dropdown changes none - so bumping a custom property on the panel's style
   gives it something to see, and draw() re-renders if the size differs.

   WHY ONE NUDGE WAS NOT ENOUGH: draw() bails when the panel is not yet visible -
   opacity under 0.02 or zero size. The theme opens dropdowns with a transition,
   so a single nudge one frame after pointerenter lands while the panel is still
   fading in, draw() returns early, and nothing happens. The nudge now repeats
   across the first half-second so at least one lands after the transition has
   settled. Each one that finds the size already stamped is free.

   ---- 3. ALIGN THE SVG TO THE BORDER EDGE ----
   The frame is painted with background-origin: border-box; the SVG is placed at
   left:0 top:0, which is the padding edge. If the panel has a border, the drawing
   is shifted inward by it. Pulling the SVG back by the computed border widths
   puts its origin where the frame starts. No-op when the border is zero.

   No font, spacing or panel property is changed by any of this. */

(function () {
  var PANELS = '.menu-list__submenu';
  var NUDGE_AT = [16, 80, 160, 260, 400, 560];

  function alignAll() {
    document.querySelectorAll('.mr-facet-svg').forEach(function (svg) {
      var p = svg.parentNode;
      if (!p || p.nodeType !== 1) return;
      var cs = getComputedStyle(p);
      var bl = parseFloat(cs.borderLeftWidth) || 0;
      var bt = parseFloat(cs.borderTopWidth) || 0;
      svg.style.left = (-bl) + 'px';
      svg.style.top = (-bt) + 'px';
    });
  }

  function redrawAll() {
    window.dispatchEvent(new Event('resize'));
    setTimeout(alignAll, 350);
  }

  /* 1. after fonts */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      redrawAll();
      setTimeout(redrawAll, 600);
    });
  }

  /* 2. on open - a short series, so one lands after the open transition */
  function nudge(panel) {
    NUDGE_AT.forEach(function (ms) {
      setTimeout(function () {
        panel.style.setProperty('--mr-open-tick', String(Date.now()));
        /* draw() defers by two frames before rendering; align after that */
        setTimeout(alignAll, 40);
      }, ms);
    });
  }

  function bind() {
    document.querySelectorAll(PANELS).forEach(function (panel) {
      var trigger = panel.parentElement;
      if (!trigger || trigger.__mrBound) return;
      trigger.__mrBound = true;
      trigger.addEventListener('pointerenter', function () { nudge(panel); });
      trigger.addEventListener('focusin', function () { nudge(panel); });
    });
    alignAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.addEventListener('load', function () {
    setTimeout(bind, 800);
    setTimeout(alignAll, 3800);
  });
})();
